<nz-segmented
  [nzOptions]="options"
  nzSize="small"
  [ngModel]="activeTheme"
  (nzValueChange)="changeTheme($event)"
></nz-segmented>
